import makeStyles from '@mui/styles/makeStyles';

const styles = makeStyles(() => ({
  buttonText: {
    font: "bold 700 16px/24px Inter",
  },
}));

export default styles;
